export default {
  figurePoly: {
    shells: [
      [
        [8,8],
        [8,11],
        [10,11],
        [10,10],
        [9,10],
        [9,9],
        [11,9],
        [11,12],
        [10,12],
        [10,13],
        [12,13],
        [12,11],
        [14,11],
        [14,12],
        [15,12],
        [15,10],
        [13,10],
        [13,8],
      ],
    ],
  },
  seahorse: {
    shells: [
      [
        [10,8],
        [14,8],
        [14,9],
        [13,9],
        [13,10],
        [15,10],
        [15,15],
        [14,15],
        [14,14],
        [11,14],
        [11,16],
        [12,16],
        [12,15],
        [13,15],
        [13,19],
        [9,19],
        [9,18],
        [10,18],
        [10,17],
        [8,17],
        [8,12],
        [9,12],
        [9,13],
        [12,13],
        [12,11],
        [11,11],
        [11,12],
        [10,12],
      ],
    ],
  },
  dice: {
    shells: [
      [
        [8,8],
        [8,11],
        [13,11],
        [13,8]],
        [[9,9],
        [9,10],
        [10,10],
        [10,9]],
        [[11,9],
        [11,10],
        [12,10],
        [12,9],
      ],
    ],
  },
  pincer: {
    shells: [
      [
        [9,8],
        [9,9],
        [8,9],
        [8,12],
        [10,12],
        [10,11],
        [9,11],
        [9,10],
        [10,10],
        [10,8],
      ],
    ],
  },
  clover: {
    shells: [
      [
        [8,8],
        [8,10],
        [9,10],
        [9,11],
        [8,11],
        [8,13],
        [10,13],
        [10,12],
        [11,12],
        [11,13],
        [13,13],
        [13,11],
        [12,11],
        [12,10],
        [13,10],
        [13,8],
        [11,8],
        [11,9],
        [10,9],
        [10,8],
      ],
    ],
  },
  opposingCups: {
    shells: [
      [
        [8,8],
        [8,14],
        [12,14],
        [12,15],
        [11,15],
        [11,16],
        [12,16],
        [12,17],
        [11,17],
        [11,18],
        [14,18],
        [14,19],
        [15,19],
        [15,18],
        [16,18],
        [16,19],
        [17,19],
        [17,13],
        [13,13],
        [13,12],
        [14,12],
        [14,11],
        [13,11],
        [13,10],
        [14,10],
        [14,9],
        [11,9],
        [11,8],
        [10,8],
        [10,9],
        [9,9],
        [9,8],
      ],
    ],
  },
  windmill: {
    shells: [
      [
        [12,11],
        [17,11],
        [17,13],
        [18,13],
        [18,14],
        [16,14],
        [16,12],
        [15,12],
        [15,17],
        [13,17],
        [13,18],
        [12,18],
        [12,16],
        [14,16],
        [14,15],
        [9,15],
        [9,13],
        [8,13],
        [8,12],
        [10,12],
        [10,14],
        [11,14],
        [11,9],
        [13,9],
        [13,8],
        [14,8],
        [14,10],
        [12,10],
      ],
    ],
  },
  square: {
    shells: [
      [
        [8,8],
        [12,8],
        [12,12],
        [8,12],
      ],
    ],
  },
  empty: {
    shells:[],
  },
  monotone: {
    shells: [
      [
        [8,11],
        [8,12],
        [12,12],
        [12,10],
        [13,10],
        [13,13],
        [16,13],
        [16,12],
        [17,12],
        [17,13],
        [18,13],
        [18,10],
        [19,10],
        [19,9],
        [15,9],
        [15,11],
        [14,11],
        [14,8],
        [11,8],
        [11,9],
        [10,9],
        [10,8],
        [9,8],
        [9,11],
      ],
    ],
  },
};
